import { useContext } from 'react';
import { useLocation, useLoaderData } from 'react-router-dom';

import DrawLocationCTS from '../components/DrawLocation/DrawLocation_CTS';
import DrawLocationNORDX from '../components/DrawLocation/DrawLocation_NORDX';
import DrawLocationXYZLABS from '../components/DrawLocation/DrawLocation_XYZLABS';
import { getSystemMsg } from '../utils/api';
import TestInfoClasses from '../components/Tests/TestInfo.module.css';
import LabIDContext from '../store/LabIDContext';

const DrawLocations  = () => {
	const systemMsg=useLoaderData();
	let defaultDL="";
	let cts='';
	let premier='';
	let nordx='';
	let xyzlabs='';
	const LabID = useContext(LabIDContext);
	const location = useLocation();
	const {orderInfo} = location.state || {};

	if(LabID === "CTS") {
		cts=1;
	}else if(LabID === "PREMIER") {
		premier=1;
	}else if(LabID === "NORDX") {
		nordx=1;
	}else if(LabID === "XYZLABS") {
		xyzlabs=1;
	}else if(systemMsg && Object.keys(systemMsg).length > 0)  {
	}else{
		defaultDL=1;
	}

    return (
		<div>
		{systemMsg && Object.keys(systemMsg).length > 0 &&
			<div className={TestInfoClasses.testInfo}>
    	    	<div className={TestInfoClasses.testInfoContent}>
    	    		<p className={TestInfoClasses.htmlText}>
			      		<span dangerouslySetInnerHTML={{__html:systemMsg}} />
			      	</p>
			     </div>
			</div>}
		{cts &&
			<DrawLocationCTS orderInfo={orderInfo} />}
		{nordx &&
			<DrawLocationNORDX />}
		{xyzlabs &&
			<DrawLocationXYZLABS orderInfo={orderInfo} />}
		{defaultDL && 
			<div align='center'>  
				<p>Thank you for ordering your tests through our Direct to Consumer portal.</p>
				<p>Please proceed to one of our convienently located draw sites with your printed requistion.</p>
				<p>Available sites are:</p>
				<p>	123 LabWay</p>
				<p>	456 Somewhere else</p>
			 </div>
		}
		</div>
    );
};

export default DrawLocations;

export async function loader() {
    const response = await getSystemMsg("DrawLocations");
	const resData = await response;
		return resData;
}